<!--修改订单价格-->
<template>
  <el-dialog title="修改订单价格"
             :visible.sync="dialogFormVisible"
             custom-class="medium-dialog"
             center
             :append-to-body="true"
             :close-on-click-modal="false"
             :modal="true">
    <el-form :model="form" ref="form1">
      <el-form-item label="" label-width="0" size="small">
        <el-table
          :data="tabledata"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            prop="seedname"
            label="名称"
            align="left"
            width="270" :show-overflow-tooltip="true"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="seedcode"
            label="编码"
            align="center"
            width="120" :show-overflow-tooltip="true"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="totalnumber"
            label="数量"
            align="center"
            width="80"
            header-align="center">
            <template slot-scope="scope">
              {{scope.row.totalnumber}}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalmoneytax"
            label="总额"
            align="center"
            width="80"
            header-align="center">
            <template slot-scope="scope">
              {{scope.row.totalmoneytax}}
            </template>
          </el-table-column>
          <el-table-column
            label="单价"
            align="center"
            width="80"
            header-align="center">
            <template slot-scope="scope">
              {{(parseFloat(scope.row.totalmoneytax)/parseFloat(scope.row.totalnumber))|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="costprice"
            label="调整单价"
            align="left"  width="100"
            header-align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.saleprice" :min="0" size="mini"
                               onfocus="this.select()" :controls="false" style="width: 76px"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            label="调整后总价"
            align="center"
            width="120"
            header-align="center">
            <template slot-scope="scope">
              {{(scope.row.saleprice*100*scope.row.totalnumber)*0.01|numeric(2)}}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="addMessage" class="qrbtn" :loading="loading">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updateSaleprice,printing} from '@/api/set/csagreement';
  import {saveData} from '@/api/set/handlelog';

  export default {
    name: "SalepriceEdit",
    data() {

      return {
        dialogFormVisible: false,
        controldata:'',
        loading:false,
        tabledata:[],
        form: {
          erpserial: '',
          pricelist: '',
        },
        formLabelWidth: '120px',
      }
    },
    methods: {
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.controldata.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = "调价"
        handlelog.remark = "调整订单单价"
        saveData(handlelog).then(response => {})
      },
      show(item) {
        this.loading = false;
        this.controldata = item;
        this.tabledata=[];
        if (item.orderfill == '80') {
          printing({
            unitguid: item.unitguid,
            erpserial: item.erpserial,
            groupguid: '',
            seedcode: ''
          }).then(response => {
            var goodsdata = response.data.obj.goodsDetail;
            for (let i in goodsdata) {
              var hasValue = false;
              for (let j in this.tabledata) {
                if (this.tabledata[j].seedcode == goodsdata[i].seedcode) {
                  this.tabledata[j].totalnumber+=parseInt(goodsdata[i]["数量"]);
                  this.tabledata[j].totalmoneytax+=parseFloat(goodsdata[i]["总价"]);
                  this.tabledata[j].saleprice = parseFloat((parseFloat(this.tabledata[j].totalmoneytax) / parseFloat(this.tabledata[j].totalnumber)).toFixed(2));
                  hasValue=true;
                  break;
                }
              }
              if (!hasValue) {
                var newRow = {
                  seedname: goodsdata[i]["产品名称"],
                  seedcode: goodsdata[i]["seedcode"],
                  totalnumber: parseInt(goodsdata[i]["数量"]),
                  totalmoneytax: parseFloat(goodsdata[i]["总价"])
                };
                newRow.saleprice = parseFloat((parseFloat(newRow.totalmoneytax) / parseFloat(newRow.totalnumber)).toFixed(2));
                this.tabledata.push(newRow);
              }
            }
          });
        } else {
          for (let i in this.controldata.jxcformdetailDOList) {
            var item = this.controldata.jxcformdetailDOList[i];
            item.saleprice = parseFloat((parseFloat(item.totalmoneytax) / parseFloat(item.totalnumber)).toFixed(2));
            this.tabledata.push(item);
          }
        }
        this.dialogFormVisible = true;
      },
      addMessage() {
        this.loading = true;
        var editprice = [];
        for (let i in this.tabledata) {
          var item = this.tabledata[i]
          if (!(item.saleprice && item.saleprice > 0)) {
            this.$message({
              message: '调价金额必须填写！',
              type: 'error'
            })
            this.loading = false;
            return;
          }
          var pricetax=(item.totalmoneytax / item.totalnumber).toFixed(2);
          if (pricetax != item.saleprice.toFixed(2)) {
            editprice.push({
              seedcode: item.seedcode,
              seedname: item.seedname,
              pricetax: pricetax,
              saleprice: item.saleprice,
              customerserial:this.controldata.customerserial,
              serveuname:this.controldata.customername,
              totalnumber:item.totalnumber
            })
          }
        }
        if (editprice.length == 0) {
          this.$message({
            message: '未修改价格！',
            type: 'error'
          })
          this.loading = false;
          return;
        }

        updateSaleprice({unitguid: this.controldata.unitguid, pricelist: JSON.stringify(editprice)}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            })
            this.handlelog();
            this.dialogFormVisible = false
            this.$emit("bindGrid");
          }else{
            this.$message({
              message: '修改失败！',
              type: 'error'
            })
            this.loading = false;
          }
        });
      },
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }

  .ddinfo {
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;

  }

  .ddinfo td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #E0DFDF;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/SalepriceEdit.vue